import { render } from "./App.vue?vue&type=template&id=1586171a"
const script = {}

import exportComponent from "../../../../bfms-portal-template-manager-20261102/stage/fms_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__